import React from "react";

const GeneralMessage = ({ icon, title, message }) => {
  return (
    <div className="flex flex-col items-center mt-[33vh] overflow-hidden">
      <div className="mb-6">
        {typeof icon === "string" ? (
          <span className="text-6xl" role="img" aria-label="Access Denied Icon">
            {icon}
          </span>
        ) : (
          icon
        )}
      </div>
      <h1 className="text-2xl text-white text-center font-bold mb-4">
        {title}
      </h1>
      <p className="mt-2 text-gray-300 text-center max-w-md">{message}</p>
    </div>
  );
};

export default GeneralMessage;
